module.exports = __webpack_public_path__ + "static/media/sunday_times.c4b4e8df.webp";